import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  getCurDateFn() {
    const date = new Date();
    return date.getTime();
  }
  getDateFn(dateString) {
    const date = new Date(dateString);
    return date.getTime();
  }
  addDay(dateString, addToDays) {
    const date = new Date(dateString);
    date.setDate(date.getDate() + addToDays);
    return date.getTime();
  }

  subDay(dateString, subToDays) {
    const date = new Date(dateString);
    date.setDate(date.getDate() - subToDays);
    return date.getTime();
  }

  addSeconds(dateString, addToSec) {
    const date = new Date(dateString);
    date.setSeconds(date.getSeconds() + addToSec);
    return date.getTime();
  }

  subSeconds(dateString, subToSec) {
    const date = new Date(dateString);
    date.setSeconds(date.getSeconds() - subToSec);
    return date.getTime();
  }
}
